<template>
  <MountingPortal mount-to="#PortalMountTo" append>
    <div
      v-if="show"
      class="tw-fixed tw-inset-0 tw-z-[10010] tw-flex tw-items-end tw-justify-center tw-bg-[#424242] tw-bg-[rgba(0,0,0,0.40)] md:tw-items-center"
      @mousedown.self="$emit('close-modal')"
    >
      <div
        class="tw-w-[480px] tw-overflow-hidden tw-rounded-t-[20px] tw-bg-white tw-shadow-[0_-10px_30px_rgba(0,0,0,0.25)] tw-transition-all tw-duration-300 tw-ease-out md:tw-rounded-[20px]"
        :class="[
          isVisible
            ? 'tw-translate-y-0 tw-opacity-100 md:tw-translate-y-0'
            : 'tw-translate-y-full tw-opacity-0 md:tw-translate-y-0',
          hasOverflow ? 'md:tw-min-w-[615px]' : 'md:tw-min-w-[600px]',
        ]"
      >
        <!-- Header -->
        <div
          class="tw-flex tw-h-[56px] tw-flex-col tw-items-start tw-justify-center tw-self-stretch tw-bg-[#0096d6] tw-px-6 tw-text-white"
        >
          <div
            class="tw-flex tw-items-start tw-justify-between tw-self-stretch tw-py-6"
          >
            <div
              class="tw-font-inter tw-text-base tw-font-semibold tw-leading-[150%] tw-text-white"
            >
              <slot name="header"></slot>
            </div>

            <button
              v-if="showCloseIcon"
              class="tw-h-6 tw-w-6"
              type="button"
              @click="$emit('close-modal')"
            >
              <!-- SVG -->
              <Close />
            </button>
          </div>
        </div>

        <!-- Body -->
        <div
          ref="scrollContainer"
          :key="viewportKey"
          :class="['tw-max-h-[80vh] tw-w-full tw-overflow-y-auto']"
        >
          <div
            :class="[
              'tw-flex tw-flex-col tw-items-center tw-justify-start tw-gap-[16px] tw-bg-white tw-text-sm md:tw-flex-row md:tw-flex-wrap md:tw-items-stretch md:tw-justify-start',
              dynamicBodyClass,
            ]"
          >
            <slot name="body"></slot>
          </div>
        </div>

        <!-- Actions -->
        <div v-if="!hideActions">
          <div
            class="tw-flex tw-h-[98px] tw-items-center tw-justify-between tw-gap-[16px] tw-self-stretch tw-border-t tw-border-gray-200 tw-bg-white tw-p-[24px]"
          >
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
    </div>
  </MountingPortal>
</template>

<script>
import Close from '@components/Student/SVG/Close.vue';

export default {
  name: 'HousemateGroupModal',
  components: { Close },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    dynamicBodyClass: {
      type: String,
      default: 'md:tw-py-[24px] md:tw-px-[24px] tw-px-[24px] tw-py-[24px]',
    },
  },
  data() {
    return {
      isVisible: false,
      viewportKey: 0,
      hasOverflow: false,
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          requestAnimationFrame(() => {
            this.isVisible = true;
          });
        } else {
          this.isVisible = false;
        }
      },
    },
  },
  mounted() {
    window.addEventListener('resize', this.recalculateOverflow);
    this.$nextTick(this.recalculateOverflow);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.recalculateOverflow);
  },
  methods: {
    close() {
      this.isVisible = false;
      setTimeout(() => {
        this.$emit('close-modal');
      }, 300);
    },

    recalculateOverflow() {
      this.viewportKey++;

      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;

        if (!el) return;

        this.hasOverflow = el.scrollHeight > el.clientHeight;
      });
    },
  },
};
</script>
